import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { startWith, Subscription } from 'rxjs';
import { AbstractControl } from '@angular/forms';

/**
 * The FormControlValuePipe takes a form control and subscribes to its valueChanges.
 */
@Pipe({
  name: 'valueChanges',
  standalone: true,
  pure: false,
})
export class ValueChangesPipe implements PipeTransform, OnDestroy {
  private subscription: Subscription | null = null;
  private value: any;
  private subscribedControl: AbstractControl | null = null;

  transform<T, TR extends T>(control: AbstractControl<T, TR>): TR {
    if (this.subscribedControl !== control) {
      if (this.subscription) this.subscription.unsubscribe();
      this.subscription = control.valueChanges
        .pipe(startWith(control.value))
        .subscribe((value) => (this.value = value));
      this.subscribedControl = control;
    }

    return this.value;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
